import { Box, Typography, Avatar, Paper, Divider } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

interface CrewMember {
  id: number;
  name: string;
  streamsAttended: number;
}

const crewMembers: CrewMember[] = [
  { id: 1, name: "Ruvarashe Makaure", streamsAttended: 3 },
  { id: 2, name: "Maxwell Manyanhaire", streamsAttended: 5 },
  { id: 3, name: "Leon Manhimanzi", streamsAttended: 2 },
  { id: 4, name: "Nashel Mashumba", streamsAttended: 8 },
];

const CrewAttendancePage = () => {
  const lowAttendanceMembers = crewMembers.filter(
    (member) => member.streamsAttended < 10,
  );

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        mt: 2,
        p: 0,
      }}
    >
      <Box sx={{ maxWidth: 600 }}>
        <CrewAttendanceCard members={lowAttendanceMembers} />
      </Box>
    </Box>
  );
};

const CrewAttendanceCard = ({ members }: { members: CrewMember[] }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "#ffffff",
      }}
    >
      <Box
        sx={{
          bgcolor: "#ffffff",
          px: 2,
          py: 1.5,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            letterSpacing: "0.05em",
            color: "#424242",
            textTransform: "uppercase",
          }}
        >
          Crew Members That Have Attended {"<"}10 Streams
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        {members.map((member, index) => (
          <Box key={member.id}>
            <MemberCard member={member} />
            {index < members.length - 1 && <Divider sx={{ my: 1 }} />}
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

const MemberCard = ({ member }: { member: CrewMember }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        borderRadius: 1,
        bgcolor: "#ffffff",
        p: 1.5,
      }}
    >
      <Avatar
        sx={{
          width: 40,
          height: 40,
          bgcolor: "#9e9e9e",
        }}
      >
        <PersonIcon sx={{ color: "#616161" }} />
      </Avatar>
      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: "#424242",
            textTransform: "uppercase",
          }}
        >
          {member.name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#757575",
            textTransform: "uppercase",
            letterSpacing: "0.03em",
          }}
        >
          Attended{" "}
          <Box component="span" sx={{ fontWeight: 700, color: "#d32f2f" }}>
            {member.streamsAttended}
          </Box>{" "}
          streams this month
        </Typography>
      </Box>
    </Box>
  );
};
export default CrewAttendancePage;
